/**
 * @file
 * Main JS for Aquaplus.
 */

 import objectFitImages from 'object-fit-images';

($ => {
  let ofiInitialized = false; // Needed for functions where you can't use .once()

  Drupal.behaviors.objectfit = {
    attach() {
      const callOfi = () => {
        if (!ofiInitialized) {
          ofiInitialized = true;


          const $img = $('img');
          $img.each(()=> {
            picturefill({element: this})
            objectFitImages(this);
          })
        }
      };

      callOfi();
    },
  };
})(jQuery);
